// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"403":"50dce5e0","435":"158df32b","453":"d855a71b","681":"d231fd34","704":"5332b9a0","887":"2f64da90","979":"a6ce1431"}[chunkId] + ".chunk.js";
};